/**
 * CoLab Language Selector Module
 * Мультимовний селектор
 */

let selector = null;
let toggle = null;
let dropdown = null;
let options = null;

function init() {
    selector = document.querySelector('.lang-selector');
    if (!selector) return;

    toggle = selector.querySelector('.lang-selector__toggle');
    dropdown = selector.querySelector('.lang-selector__dropdown');
    options = selector.querySelectorAll('.lang-selector__option');

    bindEvents();
}

function bindEvents() {
    // Toggle dropdown
    toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleDropdown();
    });

    // Select language
    options.forEach(function(option) {
        option.addEventListener('click', function(e) {
            e.preventDefault();
            selectLanguage(this);
        });
    });

    // Close on click outside
    document.addEventListener('click', function(e) {
        if (!selector.contains(e.target)) {
            closeDropdown();
        }
    });

    // Close on Escape
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeDropdown();
        }
    });
}

function toggleDropdown() {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', !isOpen);
}

function openDropdown() {
    toggle.setAttribute('aria-expanded', 'true');
}

function closeDropdown() {
    toggle.setAttribute('aria-expanded', 'false');
}

function selectLanguage(option) {
    // Don't process if already active
    if (option.classList.contains('is-active')) {
        closeDropdown();
        return;
    }

    // Update active state for visual feedback before redirect
    options.forEach(function(opt) {
        opt.classList.remove('is-active');
    });
    option.classList.add('is-active');

    // Close dropdown
    closeDropdown();

    // Trigger event for external handling
    const lang = option.getAttribute('data-lang');
    const event = new CustomEvent('languageChange', {
        detail: { language: lang }
    });
    document.dispatchEvent(event);

    // Redirect to localized URL
    const href = option.getAttribute('href');
    if (href && href !== '#') {
        window.location.href = href;
    }
}

// Public method to get current language
function getCurrentLanguage() {
    const active = selector.querySelector('.lang-selector__option.is-active');
    return active ? active.getAttribute('data-lang') : 'uk';
}

// Public method to set language (for programmatic changes)
function setLanguage(langCode) {
    options.forEach(function(option) {
        if (option.getAttribute('data-lang') === langCode) {
            selectLanguage(option);
        }
    });
}

export const Lang = {
    init,
    getCurrentLanguage,
    setLanguage
};
